import React, { createContext, useState, useContext } from 'react';
const LocationContext = createContext();
export const useLocationContext = () => useContext(LocationContext);

export const LocationProvider = ({ children }) => {
 const [locations, setLocations] = useState([]);

 return (
    <LocationContext.Provider value={{ locations, setLocations }}>
      {children}
    </LocationContext.Provider>
 );
};
